var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrowthGood({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#73d13d;opacity:0.15;}.b{fill:none;stroke:#73d13d;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-908 -3520)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 12,
    cy: 12,
    r: 12,
    transform: "translate(908 3520)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1,6,4.5,9.5,13,1m0,0H9.5M13,1V4",
    transform: "translate(913 3526.75)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrowthGood);
export default __webpack_public_path__ + "static/media/growth-good.0c98679e892357870c6fd44972a30cd2.svg";
export { ForwardRef as ReactComponent };